import React, { useEffect } from 'react';
import styles from './App.module.css';
import { About } from './components/about/About';
import { Hero } from './components/hero/Hero';
import { Projects } from './components/projects/Projects';
import Footer from './components/footer/Footer';
import './i18n';
import { useTranslation } from 'react-i18next';

const App: React.FC = () => {
  const { t, i18n } = useTranslation();

  const sections = [
    { id: 'Hero', label: t('sections.hero') },
    { id: 'About', label: t('sections.about') },
    { id: 'Projects', label: t('sections.projects') }
  ];

  useEffect(() => {
    // تغيير اتجاه النصوص بناءً على اللغة
    if (i18n.language === 'ar') {
      document.body.setAttribute('dir', 'rtl');
    } else {
      document.body.setAttribute('dir', 'ltr');
    }
  }, [i18n.language]);
  return (
    <div className={styles.app}>
      <section id="Hero"><Hero /></section>
      <section id="About"><About /></section>
      <section id="Projects"><Projects /></section>
      
      <Footer sections={sections} />
    </div>
  );
};

export default App;